export default __webpack_public_path__ + "static/media/img-result-b-small.a3ce50ca.png";